// import React from "react";
// import { Box, Button } from "grommet";
// import { useNavigate } from "react-router-dom";
// import { useParams } from "react-router-dom";

// export const ManagerDashboard = ({ color_modify }) => {
//   const navigate = useNavigate();
//   const { manager_id } = useParams();

//   return (
//     <Box direction="row" gap="small" justify="center" align="center">
//       {/* Users & Groups Button */}
//       <Button
//         label="Manage users"
//         onClick={() => navigate(`/${manager_id}/manager/users-groups`)} // Navigate to Users & Groups page
//         {...(color_modify === 1 || color_modify === 0
//           ? { primary: true }
//           : { secondary: true })}
//         width="large"
//       />

//       {/* Assessments Button */}
//       <Button
//         label="Manage assessments"
//         onClick={() => navigate(`/${manager_id}/manager/assessments`)} // Navigate to Assessments page
//         {...(color_modify === 0 || color_modify === 2
//           ? { primary: true }
//           : { secondary: true })}
//         width="large"
//       />
//     </Box>
//   );
// };

import React from "react";
import { Box, Button } from "grommet";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

export const ManagerDashboard = ({ color_modify, required }) => {
  const navigate = useNavigate();
  const { manager_id } = useParams();

  // Show buttons only if required is "yes"
  if (required !== 1) {
    return null;
  }

  return (
    <Box direction="row" gap="small" justify="center" align="center">
      {/* Users & Groups Button */}
      <Button
        label="Manage users"
        onClick={() => navigate(`/${manager_id}/manager/users-groups`)}
        {...(color_modify === 1 || color_modify === 0
          ? { primary: true }
          : { secondary: true })}
        width="large"
      />

      {/* Assessments Button */}
      <Button
        label="Manage assessments"
        onClick={() => navigate(`/${manager_id}/manager/assessments`)}
        {...(color_modify === 0 || color_modify === 2
          ? { primary: true }
          : { secondary: true })}
        width="large"
      />
    </Box>
  );
};
